import { render, staticRenderFns } from "./mg-space-item.vue?vue&type=template&id=33d5c330&scoped=true"
import script from "./mg-space-item.vue?vue&type=script&lang=js"
export * from "./mg-space-item.vue?vue&type=script&lang=js"
import style0 from "./mg-space-item.vue?vue&type=style&index=0&id=33d5c330&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d5c330",
  null
  
)

export default component.exports